export const REQUEST_COMPRESSION_THRESHOLD_BYTES = 32 * 1024;

export async function prepareJSONRequest(jsonBody, headers) {
    const rawBody = String(jsonBody || '');
    const byteLength = typeof TextEncoder === 'function' ? new TextEncoder().encode(rawBody).byteLength : rawBody.length;
    if (byteLength < REQUEST_COMPRESSION_THRESHOLD_BYTES || typeof CompressionStream !== 'function') {
        return { body: rawBody, headers };
    }

    try {
        const stream = new Blob([rawBody]).stream().pipeThrough(new CompressionStream('gzip'));
        const compressedBody = new Uint8Array(await new Response(stream).arrayBuffer());
        if (compressedBody.byteLength >= byteLength) return { body: rawBody, headers };
        return {
            body: compressedBody,
            headers: { ...headers, 'Content-Encoding': 'gzip' }
        };
    } catch (error) {
        return { body: rawBody, headers };
    }
}
